import * as React from "react";
import CountUp from "react-countup";

class IconText extends React.Component {
  render() {
    const { info } = this.props;

    return (
      <div className="iconTextContent pt-md-0 pt-sm-4 pt-3 d-flex flex-basis-100 justify-content-start flex-column align-items-center">
        <img className="height-50px" src={info.icon.src} alt={info.icon.alt} />
        <p
          className={
            "pt-25 fontWeightBold font26 letterSpacing2 text-center " + info.title.colorClass
          }
        >
          {info.title.textBefore}
          {info.title.isNum ? (
            <CountUp start={0} end={parseInt(info.title.text)} duration={3} separator=""/>
          ) : (
            info.title.text
          )}
          {info.title.textAfter}
        </p>
        <p className={"font24 px-3 text-center " + info.subtitle.colorClass}>
          {info.subtitle.text}
        </p>
      </div>
    );
  }
}

export default IconText;
